module.exports = __webpack_public_path__ + "static/media/lakeoswego-small-placeholder.08139cef.webp";